import React from "react";
import { useNavigate } from "react-router-dom";
import CopyRight from "../../Assets/CopyRight";
import Button from "../../components/Button";
import Gap from "../../components/Gap";
import LoadingFull from "../../components/LoadingFull";
import Text from "../../components/Text";
import { router } from "../../Constants";
import api from "../../request";
import { decrypt } from "../../utils/enkripsi";
import formatterMoney from "../../utils/formatMoney";
import { showLog } from "../../utils/log";
import { onHitung } from "../../utils/onHitung";
import { socket } from "../../utils/socket";

function BillCash({ }) {
  let navigate = useNavigate();
  const type = localStorage.getItem("type");
  const [dataBill, setDFataBill] = React.useState([]);
  const [transId, setTransId] = React.useState("");
  const caraBayar = localStorage.getItem("typePayment") || "";

  function prepareSocket() {
    showLog("BillCashLess Masuk prepareSocket");

    const handleSavedSi = async (arg) => {
      console.log("[socket:saved-si] payload:", arg);
      const orderDate = JSON.parse(localStorage.getItem("dataBranch"));
      const currentTransId = orderDate?.detailData;
      const incomingTransId =
        arg?.trans_id ?? arg?.transId ?? arg?.transID ?? arg?.id;

      showLog(
        `[socket:saved-si] incomingTransId=${incomingTransId} currentTransId=${currentTransId}`
      );

      if (incomingTransId && currentTransId) {
        if (String(incomingTransId) !== String(currentTransId)) return;
      }

      onRefresh("socket");
    };

    const handlePaymentSuccess = async (payload) => {
      console.log("[socket:payment-success] payload:", payload);
      const orderDate = JSON.parse(localStorage.getItem("dataBranch"));
      const currentTransId = orderDate?.detailData;
      const incomingTransId =
        payload?.trans_id ??
        payload?.transId ??
        payload?.transID ??
        payload?.id ??
        payload?.data?.trans_id;

      showLog(
        `[socket:payment-success] incomingTransId=${incomingTransId} currentTransId=${currentTransId}`
      );

      if (incomingTransId && currentTransId) {
        if (String(incomingTransId) !== String(currentTransId)) return;
      }

      onRefresh("payment-success");
    };

    const handleConnect = () => {
      showLog("Socket Connected");
    };

    socket.on("connect", handleConnect);
    socket.on("saved-si", handleSavedSi);
    socket.on("payment-success", handlePaymentSuccess);

    return () => {
      socket.off("connect", handleConnect);
      socket.off("saved-si", handleSavedSi);
      socket.off("payment-success", handlePaymentSuccess);
    };
  }

  async function printQrCode() {

    const transactionNobu = localStorage.getItem("transactionNobu") || "";

    try {
      const login = await fetch('https://uruzpro.com/transactions-services/nobu-mpm/getQRISTrans', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Accept-Encoding': 'gzip;q=1.0, compress;q=0.5',
        },
        body: JSON.stringify({
          transactionNo: transactionNobu
        }),
      });

      const resultLogin = await login.json();

      if (resultLogin && resultLogin.token) {
        console.log('hasil response login uruzpro', resultLogin);
        localStorage.setItem("tokenUruzPro", resultLogin.token);
        return resultLogin;
      } else {
        console.log('gagal login uruzpro', resultLogin);
        return;
      }
    } catch (error) {
      console.log('Terjadi error:', error);
    }
  }

  async function onRefresh(value) {
    showLog("BillCash Masuk onRefresh");
    const orderDate = JSON.parse(localStorage.getItem("dataBranch"));
    const result = await api.apiPrepare.getOrder({
      id: orderDate.detailData,
    });
    const x = onHitung(result.data);
    let sub_total = [];
    sub_total.push({
      label: "Subtotal",
      value: x?.data?.sub_total,
    });
    for (const s of x.chargeNotes) {
      sub_total.push({
        label: s.id + " " + s.percent_value + "%",
        value: s.value,
      });
    }
    sub_total.push({
      label: "Total",
      value: x?.data?.grand_total_net,
    });
    if (localStorage.getItem("typePayment") == "Cash") {
      if (result.data[0].trans_status !== 0 && value) {
        navigate(`${router}/payment-succes`);
      }
    }
    for (const index in result.data) {
      const items = result.data[index];
      setTransId(items.si_id);
      if (type == "tableQR") {
        // if (items.product_id == "QR") {
        let subtotal = 0,
          total = 0,
          tax = 0;
        for (const xi of result.data) {
          if (xi.product_id !== "QR") {
            subtotal += xi.price * xi.qty;
            total += xi.price * xi.qty;
          }
        }
        setDFataBill([
          {
            id: items.si_id,
            table_id: items.table_id,
            tanggal: items.trans_date,
            data: result.data.filter((items) => items.product_id !== "QR"),
            total: sub_total,
            trans_status: items.trans_status,
          },
        ]);
        // }
      }
      if (type == "takeaway") {
        if (index == "0") {
          let subtotal = 0,
            total = 0,
            tax = 0;
          for (const xi of result.data) {
            subtotal += xi.price * xi.qty;
            total += xi.price * xi.qty;
          }
          setDFataBill([
            {
              id: items.si_id,
              table_id: items.table_id,
              tanggal: items.trans_date,
              data: result.data.filter((items) => items.product_id !== "QR"),
              total: sub_total,
              trans_status: items.trans_status,
            },
          ]);
        }
      }
    }
  }

  React.useEffect(() => {
    showLog("BillCash Masuk useEffect 1");
    onRefresh();
    const cleanup = prepareSocket();
    return cleanup;
  }, []);

  let trans_status = "";
  if (dataBill.length !== 0 && dataBill[0]["trans_status"] == 0) {
    trans_status = "Pending";
  }
  if (dataBill.length !== 0 && dataBill[0]["trans_status"] == 1) {
    trans_status = "Sukses";
  }
  const showPayButton = trans_status === "Pending" && caraBayar !== "Cash";
  let fromPaymentSuccess = decrypt(
    JSON.parse(localStorage.getItem("fromPaymentSuccess"))
  );
  if (fromPaymentSuccess == "true") {
    const keysToKeep = [
      "type",
      "typePayment",
      "saveCustomer",
      "dataBranch",
      "fromPaymentSuccess",
      "userServer",
      "saveLinkOrder",
      "localCharges",
    ];
    const savedData = {};
    keysToKeep.forEach((key) => {
      const value = localStorage.getItem(key);
      if (value !== null) {
        savedData[key] = value;
      }
    });
    sessionStorage.clear();
    localStorage.clear();
    Object.keys(savedData).forEach((key) => {
      localStorage.setItem(key, savedData[key]);
    });
  }

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Gap height={50} />
      {trans_status === "Pending" && (
        <>
          <div
            style={{
              justifyContent: "center",
              display: "flex",
            }}
          >
            <div
              style={{
                backgroundColor: "#dcd1f4",
                padding: 16,
                borderRadius: 8,
              }}
            >
              <Text
                className="fonts700"
                style={{ fontSize: 27, textAlign: "center" }}
              >
                Harap Lakukan Pembayaran Melalui Devices Qreative Agar Order Makanan Minuman
                Bisa Diproses…
              </Text>
              <Gap height={20} />
              <Button
                onClick={() => printQrCode()}
                backgroundColor="#552CB7"
                color="#fff"
              >
                Cetak QR Code Lagi
              </Button>
            </div>
          </div>
          <Gap height={30} />
        </>
      )}
      <div
        style={{ justifyContent: "center", display: "flex", padding: "10px 0" }}
      >
        <Text className="fonts700" style={{ color: "#552CB7", fontSize: 17 }}>
          Your Bill
        </Text>
      </div>
      {dataBill &&
        dataBill.map((items, index) => {
          return (
            <div key={index} style={{ width: "100%" }}>
              <div style={{ margin: "0 30px" }}>
                <Text style={{ fontSize: 15 }} className="fonts500">
                  {items.id}
                </Text>
              </div>
              <Gap height={20} />
              <div
                style={{
                  border: `0.1px solid #BFBFBF`,
                  backgroundColor: "#fff",
                  borderRadius: 10,
                  margin: "0 20px",
                }}
              >
                <div style={{ margin: "20px 20px" }}>
                  {/* {type == "tableQR" && (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <span style={{ fontSize: 15 }} className="fonts500">
                        Nomer Meja
                      </span>
                      <span style={{ fontSize: 15 }} className="fonts500">
                        {items.table_id}
                      </span>
                    </div>
                  )} */}
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <Text style={{ fontSize: 15 }} className="fonts500">
                      Tanggal
                    </Text>
                    <Text style={{ fontSize: 15 }} className="fonts500">
                      {items.tanggal}
                    </Text>
                  </div>
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <Text style={{ fontSize: 15 }} className="fonts500">
                      Status
                    </Text>
                    <Text
                      style={{
                        fontSize: 15,
                        color:
                          trans_status == "Pending" ? "#F8991F" : "#26D044",
                      }}
                      className="fonts700"
                    >
                      {trans_status}
                    </Text>
                  </div>
                </div>
              </div>
              <Gap height={20} />
              <div
                style={{
                  border: `0.1px solid #BFBFBF`,
                  backgroundColor: "#fff",
                  borderRadius: 10,
                  margin: "0 20px",
                }}
              >
                <div style={{ margin: "20px 20px" }}>
                  {items.data.map((item, index) => {
                    let is_prepared = "";
                    // if (item.is_prepared == 0) {
                    //     is_prepared = "Sedang disiapkan"
                    // }
                    if (item.is_prepared == 1) {
                      is_prepared = "Sudah disiapkan";
                    }
                    return (
                      <div key={index}>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <div>
                            <div
                              style={{
                                display: "flex",
                                justifyItems: "center",
                              }}
                            >
                              <span className="fonts700">{item.qty}x</span>
                              <Gap width={10} />
                              <span className="fonts500">
                                {(item.name || "")
                                  .split(" ")
                                  .map(
                                    (word) =>
                                      word.charAt(0).toUpperCase() +
                                      word.slice(1).toLowerCase()
                                  )
                                  .join(" ")}{" "}
                              </span>
                            </div>
                            {item.detail_note && (
                              <div
                                className="fonts500"
                                style={{ fontSize: 14, color: "#BFBFBF" }}
                              >
                                {item.detail_note}
                              </div>
                            )}
                            {is_prepared !== "" && <Gap height={10} />}
                            {is_prepared !== "" && (
                              <span
                                className="fonts500"
                                style={{
                                  fontSize: 14,
                                  color:
                                    item.is_prepared == 0
                                      ? "#F8991F"
                                      : "#26D044",
                                }}
                              >
                                {is_prepared}
                              </span>
                            )}
                          </div>
                          <div>
                            <div className="fonts700">
                              Rp{formatterMoney(item.price * item.qty)}
                            </div>
                          </div>
                        </div>
                        <Gap height={10} />
                      </div>
                    );
                  })}
                </div>
              </div>
              <Gap height={20} />
              <div
                style={{
                  border: `0.1px solid #BFBFBF`,
                  backgroundColor: "#fff",
                  borderRadius: 10,
                  margin: "0 20px",
                }}
              >
                <div style={{ margin: "20px 20px" }}>
                  {items.total.map((items, index) => (
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginTop: 10,
                      }}
                    >
                      <div>
                        <div className="fonts700">{items.label}</div>
                      </div>
                      <div>
                        <div className="fonts700">
                          Rp{formatterMoney(items.value)}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          );
        })}
      {dataBill.length == 0 && <LoadingFull />}
      <Gap height={40} />
      <div style={{ marginTop: 20, textAlign: "center" }}>
        <CopyRight />
      </div>
      <Gap height={20} />
    </div>
  );
}

export default BillCash;
